import { Typography, styled } from '@material-ui/core';
import { NkSectionTitleProps } from './NkSectionTitle.types';
import { PropsWithChildren } from 'react';

export const NkSectionTitle = ({
  children,
  title,
  ...typographyProps
}: PropsWithChildren<NkSectionTitleProps>): JSX.Element => {
  return (
    <StyledTitle>
      <StyledTypography variant="h6" {...typographyProps}>
        {title ? title : children}
      </StyledTypography>
    </StyledTitle>
  );
};

const StyledTypography = styled(Typography)({
  fontWeight: 500,
  fontSize: 16,
});

const StyledTitle = styled('div')(({ theme }) => ({
  background: theme.customProps.header.backgroundColor,
  color: theme.customProps.header.textColor,
  padding: theme.spacing() / 2,
  marginBottom: 4,
}));
